import type { UiFeatureFlagsResponse } from '@xpanse/organization-service-client';

/**
 * Locally declared UI flags until organization-service publishes them on
 * `UiFeatureFlagsResponse`. Once the OpenAPI spec carries these fields, run
 * `yarn generate` and drop this intersection.
 */
export type UiFeatureFlags = UiFeatureFlagsResponse & {
  viewOrderEventSearch?: boolean;
  viewEmailSubscription?: boolean;
  viewClosingSearchFilters?: boolean;
  viewAttachmentTypeSearchFilters?: boolean;
  viewClearToCloseDocumentationReport?: boolean;
  viewEventTypeAdvancedFilters?: boolean;
  showAllAllocationOperatorOptions?: boolean;
  createAttributeDictionary?: boolean;
  tenantConfigFeatureControl?: boolean;
};

export const defaultUiFeatureFlags: UiFeatureFlags = {
  viewVendors: false,
  viewDeliveryFailureWarning: false,
  viewAllocation: false,
  viewClosingSearchFilters: false,
  viewAttachmentTypeSearchFilters: false,
  viewClearToCloseDocumentationReport: false,
  viewOrderEventSearch: false,
  viewEmailSubscription: false,
  viewEventTypeAdvancedFilters: false,
  showAllAllocationOperatorOptions: false,
  createAttributeDictionary: false,
  tenantConfigFeatureControl: false,
};
